export default "__VITE_ASSET__BarSGleH__"